import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'interactive-access',
    name: 'InteractiveAccess',
    component: () => import('~/views/interactiveAccess/InteractiveAccess.vue'),
    meta: { title: 'СКУД' }
  },

  // interactive access objects
  {
    path: 'interactive-access/interactive-access-objects',
    name: 'InteractiveAccessObjects',
    component: () => import('~/views/interactiveAccess/lists/interactiveAccessObjects/InteractiveAccessObjects.vue'),
    meta: { title: 'Объекты СКУД' }
  },
  {
    path: 'interactive-access/interactive-access-objects/detail/:id?',
    name: 'InteractiveAccessObject',
    component: () => import('~/views/interactiveAccess/list-items/interactiveAccessObjects/InteractiveAccessObject.vue'),
    meta: { title: 'Объект СКУД' }
  },
  {
    path: 'interactive-access/interactive-access-object-servers',
    name: 'InteractiveAccessObjectServers',
    component: () => import('~/views/interactiveAccess/lists/interactiveAccessObjects/InteractiveAccessObjectServers.vue'),
    meta: { title: 'Серверы СКУД' }
  },
  {
    path: 'interactive-access/interactive-access-object-servers/detail/:id?',
    name: 'InteractiveAccessObjectServer',
    component: () => import('~/views/interactiveAccess/list-items/interactiveAccessObjects/InteractiveAccessObjectServer.vue'),
    meta: { title: 'Сервер СКУД' }
  },
  {
    path: 'interactive-access/interactive-access-object-types',
    name: 'InteractiveAccessObjectTypes',
    component: () => import('~/views/interactiveAccess/lists/interactiveAccessObjects/InteractiveAccessObjectTypes.vue'),
    meta: { title: 'Типы объектов СКУД' }
  },
  {
    path: 'interactive-access/interactive-access-object-types/detail/:id?',
    name: 'InteractiveAccessObjectType',
    component: () => import('~/views/interactiveAccess/list-items/interactiveAccessObjects/InteractiveAccessObjectType.vue'),
    meta: { title: 'Тип объекта СКУД' }
  },

  // Video recorders
  {
    path: 'interactive-access/video-recorders',
    name: 'VideoRecorders',
    component: () => import('~/views/interactiveAccess/lists/cameras/VideoRecorders.vue'),
    meta: { title: 'Видеорегистраторы' }
  },

  {
    path: 'interactive-access/video-recorders/detail/:id?',
    name: 'VideoRecorder',
    component: () => import('~/views/interactiveAccess/list-items/cameras/VideoRecorder.vue'),
    meta: { title: 'Видеорегистратор' }
  },

  // House-cameras
  {
    path: 'interactive-access/house-cameras',
    name: 'HouseCameras',
    component: () => import('~/views/interactiveAccess/lists/cameras/HouseCameras.vue'),
    meta: { title: 'Камеры домов' }
  },

  {
    path: 'interactive-access/house-cameras/detail/:id?',
    name: 'HouseCamera',
    component: () => import('~/views/interactiveAccess/list-items/cameras/HouseCamera.vue'),
    meta: { title: 'Камера дома' }
  },

  {
    path: 'interactive-access/object-groups',
    name: 'ObjectGroups',
    component: () => import('~/views/interactiveAccess/lists/cameras/ObjectGroups.vue'),
    meta: { title: 'Группы камер и объектов доступа' }
  },

  {
    path: 'interactive-access/object-groups/detail/:id?',
    name: 'ObjectGroup',
    component: () => import('~/views/interactiveAccess/list-items/cameras/ObjectGroup.vue'),
    meta: { title: 'Группа камер и объектов доступа' }
  },

  {
    path: 'interactive-access/cameras/web-cams-availability-report',
    name: 'WebCamsAvailabilityReport',
    component: () =>
      import(
        '~/views/interactiveAccess/reports/WebCamsAvailabilityReport.vue'
        ),
    meta: { title: 'Отчет по доступности камер' }
  },

  // { START } users
  // premises intercoms

  {
    path: 'interactive-access/premises-intercoms',
    name: 'PremisesIntercoms',
    component: () =>
      import('~/views/interactiveAccess/lists/users/PremisesIntercoms.vue'),
    meta: { title: 'Пользователи объектов доступа' }
  },

  {
    path: 'interactive-access/premises-intercoms/detail/:id?',
    name: 'PremisesIntercom',
    component: () =>
      import('~/views/interactiveAccess/list-items/users/PremisesIntercom.vue'),
    meta: { title: 'Пользователь объекта доступа' }
  },
  {
    path: 'interactive-access/premises-intercoms/detail/:parentId/interactive-access-for-premises-intercoms',
    name: 'InteractiveAccessObjectsForPremisesIntercom',
    component: () => import('~/views/interactiveAccess/lists/users/InteractiveAccessObjectsForPremisesIntercom.vue'),
    meta: { title: 'Объекты СКУД' }
  },
  // { START } downloads
  {
    path: 'interactive-access/import-users',
    name: 'ImportPremisesIntercoms',
    component: () =>
      import('~/views/interactiveAccess/file-analysis/ImportPremisesIntercoms.vue'),
    meta: { title: 'Загрузка пользователей объектов доступа' }
  },

  // { START } users
  // long process
  {
    path: 'interactive-access/owners-lists/premises/import-premise-gis-number',
    name: 'InteractiveAccessImportPremiseGisNumber',
    component: () =>
      import(
        '~/views/interactiveAccess/file-analysis/ImportPremiseGisNumber.vue'
        ),
    meta: { title: 'Импорт номеров помещений ГИС' }
  },

  // Journals
  {
    path: 'interactive-access/interactive-access-objects-activations-log',
    name: 'InteractiveAccessObjectsActivationsLog',
    component: () => import('~/views/interactiveAccess/lists/journal/InteractiveAccessObjectsActivationsLog.vue'),
    meta: { title: 'Журнал активации объектов СКУД' }
  },

  {
    path: 'interactive-access/interactive-access-objects-push-log',
    name: 'InteractiveAccessObjectsPushLog',
    component: () => import('~/views/interactiveAccess/lists/journal/InteractiveAccessObjectsPushLog.vue'),
    meta: { title: 'Журнал вызовов домофона' }
  },

  {
    path: 'interactive-access/interactive-access-objects-push-log/detail/:id?',
    name: 'InteractiveAccessObjectsPush',
    component: () => import('~/views/interactiveAccess/list-items/journal/InteractiveAccessObjectsPush.vue'),
    meta: { title: 'Вызов домофона' }
  },

  {
    path: 'interactive-access/interactive-access-objects-push-log/detail/:parentId?/user-log-information',
    name: 'UserLogInformationForPushLogEdit',
    component: () => import('~/views/interactiveAccess/lists/journal/UserLogInformationForPushLogEdit.vue'),
    meta: { title: 'Информация о событиях пользователя' }
  },

  {
    path: 'interactive-access/interactive-access-objects-push-log/detail/:parentId?/interactive-access-objects-push-log/activations-log',
    name: 'InteractiveAccessObjectsActivationsLogForPushLogEdit',
    component: () => import('~/views/interactiveAccess/lists/journal/InteractiveAccessObjectsActivationsLogForPushLogEdit.vue'),
    meta: { title: 'Журнал активации объектов СКУД' }
  },

  {
    path: 'interactive-access/interactive-access-objects-push-log/detail/:parentId?/interactive-access-objects-push-log/delegated-rights',
    name: 'DelegatedRightsForPushLogEdit',
    component: () => import('~/views/interactiveAccess/lists/journal/DelegatedRightsForPushLogEdit.vue'),
    meta: { title: 'Выданные права доступа' }
  },

  {
    path: 'interactive-access/journal/delegated-rights',
    name: 'DelegatedRights',
    component: () => import('~/views/interactiveAccess/lists/journal/DelegatedRights.vue'),
    meta: { title: 'Выданные права доступа' }
  },

  {
    path: 'interactive-access/delegated-rights/detail/:id?',
    name: 'DelegatedRight',
    component: () => import('~/views/interactiveAccess/list-items/journal/DelegatedRight.vue'),
    meta: { title: 'Детализация прав доступа' }
  },

  {
    path: 'interactive-access/user-log-in-formation',
    name: 'UserLogInformation',
    component: () => import('~/views/interactiveAccess/lists/journal/UserLogInformation.vue'),
    meta: { title: 'Информация о событиях пользователя' }
  },
  {
    path: 'interactive-access/journal/user-log-analitic',
    name: 'UserLogAnalitic',
    component: () => import('~/views/interactiveAccess/lists/journal/UserLogAnalitic.vue'),
    meta: { title: 'Информация о событиях пользователя (с фильтром для аналитики)' }
  },

  // Addresses

  {
    path: 'interactive-access/district-divisions',
    name: 'InteractiveAccessDistrictDivisions',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessDistrictDivisions.vue'),
    meta: { title: 'Дивизионы групп районов' }
  },

  {
    path: 'interactive-access/district-divisions/detail/:id?',
    name: 'InteractiveAccessDistrictDivision',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessDistrictDivision.vue'),
    meta: { title: 'Дивизион групп районов' }
  },

  {
    path: 'interactive-access/groups-of-districts',
    name: 'InteractiveAccessGroupsOfDistricts',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessGroupsOfDistricts.vue'),
    meta: { title: 'Группы районов' }
  },

  {
    path: 'interactive-access/groups-of-districts/detail/:id?',
    name: 'InteractiveAccessGroupOfDistricts',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessGroupOfDistricts.vue'),
    meta: { title: 'Группа районов' }
  },

  {
    path: 'interactive-access/home-groups',
    name: 'InteractiveAccessHomeGroups',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHomeGroups.vue'),
    meta: { title: 'Районы' }
  },

  {
    path: 'interactive-access/home-groups/detail/:id?',
    name: 'InteractiveAccessHomeGroup',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessHomeGroup.vue'),
    meta: { title: 'Район' }
  },

  {
    path: 'interactive-access/houses',
    name: 'InteractiveAccessHouses',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHouses.vue'),
    meta: { title: 'Дома' }
  },

  {
    path: 'interactive-access/accounts',
    name: 'InteractiveAccess.Accounts',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessAccounts.vue'),
    meta: { title: 'Лицевые счета' }
  },
	{
    path: 'interactive-access/houses/detail/:id?',
    name: 'InteractiveAccessHouse',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessHouse.vue'),
    meta: { title: 'Дом' }
  },
	{
    path: 'interactive-access/houses/detail/:parentId/entrances',
    name: 'InteractiveAccessEntrancesForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessEntrancesForHouse.vue'),
    meta: { title: 'Подъезды' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/entrances/detail/:id?',
    name: 'InteractiveAccessEntranceForHouse',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessEntranceForHouse.vue'),
    meta: { title: 'Подъезд' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/meters',
    name: 'InteractiveAccessHouseMetersForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHouseMetersForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/meters/detail/:id?',
    name: 'InteractiveAccessHouseMeterForHouse',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessHouseMeterForHouse.vue'),
    meta: { title: 'ОДПУ' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/lifts',
    name: 'InteractiveAccessLiftsForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessLiftsForHouse.vue'),
    meta: { title: 'Лифты' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/cameras',
    name: 'InteractiveAccessHouseCamerasForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHouseCamerasForHouse.vue'),
    meta: { title: 'Камеры' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/cameras/detail/:id?',
    name: 'InteractiveAccessHouseCameraForHouse',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessHouseCameraForHouse.vue'),
    meta: { title: 'Камера' }
  },
	  {
    path: 'interactive-access/houses/detail/:parentId/meters/detail/:id/meter-values',
    name: 'InteractiveAccessHouseMeterValuesForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHouseMeterValuesForHouse.vue'),
    meta: { title: 'Показания ОДПУ' }
  },
  {
    path: 'interactive-access/houses/detail/:parentId/meters/detail/:id/meter-verifications',
    name: 'InteractiveAccessHouseMeterVerificationsForHouse',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessHouseMeterVerificationsForHouse.vue'),
    meta: { title: 'Поверки ОДПУ' }
  },

  {
    path: 'interactive-access/accounts/detail/:id?',
    name: 'InteractiveAccess.Account',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },
	{
    path: 'interactive-access/accounts/fill-template-tko-accounts-processor',
    name: 'InteractiveAccess.FillTemplateTKOAccountsProcessor',
    component: () => import('~/components/view/common/long-process/FillTemplateTKOAccountsProcessor.vue'),
    meta: { title: 'Выгрузить ЛС ТКО' }
  },
  {
    path: 'interactive-access/accounts/accounts-csv-file-processor',
    name: 'InteractiveAccess.AccountsCsvFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsCsvFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в CSV' }
  },
  {
    path: 'interactive-access/accounts/accounts-excel-file-processor',
    name: 'InteractiveAccess.AccountsExcelFileProcessor',
    component: () => import('~/components/view/common/long-process/AccountsExcelFileProcessor.vue'),
    meta: { title: 'Выгрузить ЛС/ЕЛС в Excel' }
  },
  {
    path: 'interactive-access/accounts/create-cr-accounts-processor',
    name: 'InteractiveAccess.CreateCRAccountsProcessor',
    component: () => import('~/components/view/common/long-process/CreateCRAccountsProcessor.vue'),
    meta: { title: 'Создать лицевые счета для кап.ремонта' }
  },
  {
    path: 'interactive-access/accounts/account-from-tko-template-processor',
    name: 'InteractiveAccess.AccountFromTkoTemplateProcessor',
    component: () => import('~/components/view/common/long-process/AccountFromTkoTemplateProcessor.vue'),
    meta: { title: 'Обновить ИЖКУ по результатам обработки шаблона ЛС ТКО' }
  },
	{
    path: 'interactive-access/accounts/detail/:parentId/mobile-accounts-for-account',
    name: 'InteractiveAccess.MobileAccountsForAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/MobileAccountsForAccount.vue'),
    meta: { title: 'Мобильные аккаунты' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/mobile-accounts-for-account/detail/:id?',
    name: 'InteractiveAccess.MobileAccountForAccount',
    component: () => import('~/views/interactiveAccess/list-items/addresses/MobileAccountForAccount.vue'),
    meta: { title: 'Мобильный аккаунт' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/bills-for-account',
    name: 'InteractiveAccess.BillsForAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/BillsForAccount.vue'),
    meta: { title: 'Квитанции' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/meters-for-account',
    name: 'InteractiveAccess.MetersForAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/MetersForAccount.vue'),
    meta: { title: 'Приборы учета' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/notification-send-logs-for-account',
    name: 'InteractiveAccess.NotificationSendLogsForAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/NotificationSendLogsForAccount.vue'),
    meta: { title: 'Логи уведомлений' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/claimants-for-account',
    name: 'InteractiveAccess.ClaimantsForAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/ClaimantsForAccount.vue'),
    meta: { title: 'Взыскатели' }
  },
  {
    path: 'interactive-access/accounts/detail/:parentId/claimants-for-account/detail/:id?',
    name: 'InteractiveAccess.ClaimantForAccount',
    component: () => import('~/views/interactiveAccess/list-items/addresses/ClaimantForAccount.vue'),
    meta: { title: 'Взыскатель' }
  },
  {
    path: 'interactive-access/premises',
    name: 'InteractiveAccessPremises',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessPremises.vue'),
    meta: { title: 'Помещения' }
  },

  {
    path: 'interactive-access/premises/detail/:id?',
    name: 'InteractiveAccessPremise',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessPremise.vue'),
    meta: { title: 'Помещение' }
  },

  {
    path: 'interactive-access/mobile-users',
    name: 'InteractiveAccess.MobileAccounts',
    component: () => import('~/views/interactiveAccess/lists/addresses/InteractiveAccessMobileAccounts.vue'),
    meta: { title: 'Мобильные пользователи' }
  },

  {
    path: 'interactive-access/mobile-users/detail/:id?',
    name: 'InteractiveAccess.MobileAccount',
    component: () => import('~/views/interactiveAccess/list-items/addresses/InteractiveAccessMobileAccount.vue'),
    meta: { title: 'Мобильный пользователь' }
  },

  {
    path: 'interactive-access/mobile-users/detail/:parentId?/devices-for-mobile-account',
    name: 'InteractiveAccess.DevicesForMobileAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/DevicesForMobileAccount.vue'),
    meta: { title: 'Устройства' }
  },
{
    path: 'interactive-access/mobile-users/detail/:parentId/accounts-for-mobile-account',
    name: 'InteractiveAccess.AccountsForMobileAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/AccountsForMobileAccount.vue'),
    meta: { title: 'Лицевые счета' }
  },
  {
    path: 'interactive-access/mobile-users/detail/:parentId/accounts-for-mobile-account/detail/:id?',
    name: 'InteractiveAccess.AccountForMobileAccount',
    component: () => import('~/views/interactiveAccess/list-items/addresses/AccountForMobileAccount.vue'),
    meta: { title: 'Лицевой счет' }
  },
  {
    path: 'interactive-access/mobile-users/detail/:parentId/account-link-logs-for-mobile-account',
    name: 'InteractiveAccess.AccountLinkLogsForMobileAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/AccountLinkLogsForMobileAccount.vue'),
    meta: { title: 'Лог привязки лс' }
  },
  {
    path: 'interactive-access/mobile-users/detail/:parentId/objects-for-mobile-account',
    name: 'InteractiveAccess.ObjectsForMobileAccount',
    component: () => import('~/views/interactiveAccess/lists/addresses/ObjectsForMobileAccount.vue'),
    meta: { title: 'Объекты СКУД' }
  },
  // { END } downloads
  // { START } long process
  {
    path: 'interactive-access/ats-fill-premises-by-house-processor',
    name: 'InteractiveAccess.AtsFillPremisesByHouseProcessor',
    component: () => import('~/views/interactiveAccess/long-process/AtsFillPremisesByHouseProcessor.vue'),
    meta: { title: 'Записать данные АТС в помещения' }
  },
  {
    path: 'interactive-access/export-houses-to-excel-processor',
    name: 'InteractiveAccess.ExportHousesToExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesToExcelProcessor.vue'),
    meta: { title: 'Выгрузить доп. информацию по домам (XLSX)' }
  },
  {
    path: 'interactive-access/export-houses-without-fias-processor',
    name: 'InteractiveAccess.ExportHousesWithoutFiasProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesWithoutFiasProcessor.vue'),
    meta: { title: 'Выгрузить дома без ФИАС в CSV файл' }
  },
  {
    path: 'interactive-access/ExportPremiseGisNumberProcessor',
    name: 'InteractiveAccess.ExportPremiseGisNumberProcessor',
    component: () => import('~/views/interactiveAccess/long-process/ExportPremiseGisNumberProcessor.vue'),
    meta: { title: 'Экспорт номеров помещений ГИС в Excel' }
  },
  {
    path: 'interactive-access/house-creation-master-processor',
    name: 'InteractiveAccess.HouseCreationMasterProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseCreationMasterProcessor.vue'),
    meta: { title: 'Мастер создания дома' }
  },
  {
    path: 'interactive-access/house-fiases-processor',
    name: 'InteractiveAccess.HouseFiasesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseFiasesProcessor.vue'),
    meta: { title: 'Загрузить ФИАСы' }
  },
  {
    path: 'interactive-access/houses-for-tko-contract-processor',
    name: 'InteractiveAccess.HousesForTkoContractProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HousesForTkoContractProcessor.vue'),
    meta: { title: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)' }
  },
  {
    path: 'interactive-access/house-type-by-premise-type-processor',
    name: 'InteractiveAccess.HouseTypeByPremiseTypeProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseTypeByPremiseTypeProcessor.vue'),
    meta: { title: 'Изменение типа домов по кол-ву помещений' }
  },
  {
    path: 'interactive-access/import-houses-from-excel-processor',
    name: 'InteractiveAccess.ImportHousesFromExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ImportHousesFromExcelProcessor.vue'),
    meta: { title: 'Загрузить доп. информацию по домам (XLSX)' }
  },
  {
    path: 'interactive-access/premises-not-linked-to-account-remove-processor',
    name: 'InteractiveAccess.PremisesNotLinkedToAccountRemoveProcessor',
    component: () => import('~/views/electronic-control-room/long-process/PremisesNotLinkedToAccountRemoveProcessor.vue'),
    meta: { title: 'Удалить помещения, не привязанные к ЛС' }
  },
  {
    path: 'interactive-access/update-houses-addresses-processor',
    name: 'InteractiveAccess.UpdateHousesAddressesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/UpdateHousesAddressesProcessor.vue'),
    meta: { title: 'Обновление адресов домов' }
  },
  // { END } long process
  // { START } reports
  {
    path: 'interactive-access/ats-intercoms-report',
    name: 'InteractiveAccess.AtsIntercomsReport',
    component: () => import('~/views/interactiveAccess/reports/AtsIntercomsReport.vue'),
    meta: { title: 'Аккаунты АТС домофонов' }
  },
  {
    path: 'interactive-access/ats-premises-report',
    name: 'InteractiveAccess.AtsPremisesReport',
    component: () => import('~/views/interactiveAccess/reports/AtsPremisesReport.vue'),
    meta: { title: 'Аккаунты АТС помещений' }
  },
  {
    path: 'interactive-access/user-log-analitic-report',
    name: 'InteractiveAccess.UserLogAnaliticReport',
    component: () => import('~/views/interactiveAccess/reports/UserLogAnaliticReport.vue'),
    meta: { title: 'Отчет по журналу звонков' }
  },
  {
    path: 'interactive-access/interactive-object-activate-error-statistic-report',
    name: 'InteractiveAccess.InteractiveObjectActivateErrorStatisticReport',
    component: () => import('~/views/interactiveAccess/reports/InteractiveObjectActivateErrorStatisticReport.vue'),
    meta: { title: 'Статистика ошибок активации объектов СКУД' }
  },
  // { END } reports
  // { START } settings
  {
    path: 'interactive-access/settings/interactive-access-objects',
    name: 'InteractiveAccess.ObjectsSettings',
    component: () => import('~/views/interactiveAccess/settings/InteractiveAccessObjectsSettings.vue'),
    meta: { title: 'Настройки СКУД' }
  },
  // { END } settings

];